import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { httpRequest } from "../../redux/Action";
import { API_END_POINTS } from "../../api/ApiEndPonts";
import Loader from "../Loader";

function Topics() {
  const { subjectId } = useParams();
  const dispatch = useDispatch();

  const topicState =
    useSelector((state) => state.apiReducer.getTopicsBySubjectId ) || {};

  const { response, loading, error } = topicState;

  useEffect(() => {
    if (subjectId) {
      dispatch(
        httpRequest({
          key: API_END_POINTS.getTopicsBySubjectId.KEY,
          params: { id: subjectId  }, // 👈 IMPORTANT
        })
      );
    }
  }, [subjectId, dispatch]);


const topics = Array.isArray(response?.data) 
  ? response.data 
  : response?.data?.topics || []; 

  return (
    <div className="container mt-4">
  <div className="d-flex align-items-center mb-4">
    <div className="back-button me-3" onClick={() => window.history.back()} style={{cursor: 'pointer'}}>
       <i className="bi bi-arrow-left-circle-fill fs-3 text-primary"></i>
    </div>
    <h3 className="fw-bold m-0">Course Content</h3>
  </div>

  {loading && <Loader />}
  {error && Object.keys(error).length > 0 && (
  <p style={{ color: "red" }}>
    {typeof error === 'object' 
      ? (error.message || JSON.stringify(error)) 
      : error}
  </p>
)}

  <div className="row justify-content-center">
    <div className="col-lg-10">
      {topics.length > 0 ? (
        topics.map((t, index) => (
          <div className="topic-list-item mb-3 p-3 d-flex align-items-center" key={t._id}>
            <div className="topic-number me-3">{index + 1}</div>
            <div className="flex-grow-1">
              <h6 className="mb-0 fw-700 text-dark">{t.title}</h6>
              <small className="text-muted">Chapter {index + 1} • 15 Questions</small>
            </div>
            <button className="btn btn-sm btn-outline-primary rounded-pill px-3">
              Start <i className="bi bi-play-fill"></i>
            </button>
          </div>
        ))
      ) : (
        !loading && <Loader />
      )}
    </div>
  </div>
</div>
  );
}

export default Topics;